import { render } from "./J03AResultScreen.vue?vue&type=template&id=518ed59e&scoped=true&ts=true"
import script from "./J03AResultScreen.vue?vue&type=script&lang=ts"
export * from "./J03AResultScreen.vue?vue&type=script&lang=ts"

import "./J03AResultScreen.vue?vue&type=style&index=0&id=518ed59e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518ed59e"]])

export default __exports__